<div class="custom-stepper">
  @if (isReadOnly) {
  <div class="read-only-banner read-only-banner-style">
    <mat-icon style="color:#856404;">lock</mat-icon>
    <span style="color:#856404; font-weight:500;">{{ variables.readOnlyEstimateMessage }}</span>
  </div>
  }
  <!-- Phase navigation tabs for scrolling within the estimation form -->
  <div class="page-header-step">
    <div class="section-tabs mt-2">
      <div [class.tab-is-selected]="currentActive === 1" (click)="scrollToTarget(technologySection, 1)" class="tab">
        <mat-icon>assignment</mat-icon> {{ variables.estimation }}
      </div>

      @if (projectTypes.length > 0 && !isServiceCatalog) {
      <div [class.tab-is-selected]="currentActive === 3" (click)="scrollToTarget(projectTypeSection, 3)" class="tab">
        <mat-icon>assignment</mat-icon> {{ variables.projectType }}
      </div>
      }

      @if (configurations.length > 0 && !isServiceCatalog) {
      <div [class.tab-is-selected]="currentActive === 5" (click)="scrollToTarget(configurationSection, 5)" class="tab">
        <mat-icon>assignment</mat-icon> {{ variables.configuration }}
      </div>
      }

      @if (parameters.length > 0 && !isServiceCatalog) {
      <div [class.tab-is-selected]="currentActive === 6" (click)="scrollToTarget(parametersSection, 6)" class="tab">
        <mat-icon>assignment</mat-icon> {{ variables.parameters }}
      </div>
      }

      @if (macroActivities.length > 0 && !isServiceCatalog) {
      <div [class.tab-is-selected]="currentActive === 7" (click)="scrollToTarget(macroSection, 7)" class="tab">
        <mat-icon>assignment</mat-icon> {{ variables.macroActivities }}
      </div>
      }
    </div>
  </div>

  <div class="form-box">
    <form [formGroup]="estimativaForm">
      <div class="section">
        <h3 #technologySection class="section-name">{{ variables.estimation }} <span>*</span></h3>

        <div class="form-group">
          <label class="mb-2 input-label mandatory"><span>*</span> {{ variables.estimateName }}</label>
          <mat-form-field class="form-field" appearance="outline">
            <input matInput placeholder="Estimativa 10" formControlName="nameCtrl">
            @if (invalidFields.name) {
            <mat-hint class="error-hint">{{ fieldsErrorMessages.name }}</mat-hint>
            }
          </mat-form-field>
        </div>

        <div class="form-group">
          <label class="mb-2 input-label mandatory"><span>*</span> {{ variables.impactClientOrMapfre }}</label>
          <mat-form-field class="form-field" appearance="outline">
            <mat-select formControlName="critQuestion1Ctrl" placeholder="">
              @for (item of crit1Options; track $index) {
              <mat-option [value]="item.value">
                {{ item.name }}
              </mat-option>
              }
            </mat-select>
            @if (invalidFields.critQuestion1) {
            <mat-hint class="error-hint">{{ fieldsErrorMessages.critQuestion1 }}</mat-hint>
            }
          </mat-form-field>
        </div>

        <div class="form-group">
          <label class="mb-2 input-label mandatory"><span>*</span> {{ variables.impactClientBusiness }}</label>
          <mat-form-field class="form-field" appearance="outline">
            <mat-select formControlName="critQuestion2Ctrl" placeholder="">
              @for (item of crit1Options; track $index) {
              <mat-option [value]="item.value">
                {{ item.name }}
              </mat-option>
              }
            </mat-select>
            @if (invalidFields.critQuestion2) {
            <mat-hint class="error-hint">{{ fieldsErrorMessages.critQuestion2 }}</mat-hint>
            }
          </mat-form-field>
        </div>

        <div class="form-group">
          <label class="mb-2 input-label mandatory"><span>*</span> {{ variables.associateEstimate }}</label>
          <mat-form-field class="form-field" appearance="outline">
            <mat-select formControlName="projectCtrl" placeholder="" [disabled]="isProjectDropdownDisabled">
              <mat-option>
                <ngx-mat-select-search formControlName="projectFilterCtrl" [placeholderLabel]="variables.search"
                  [noEntriesFoundLabel]="variables.noProjectFound" search
                  (keyup)="filterProjects()"></ngx-mat-select-search>
              </mat-option>
              @for (item of filteredProjects; track item.id) {
              <mat-option [value]="item.id">
                {{ item.name }}
              </mat-option>
              }
            </mat-select>
            @if (invalidFields.project) {
            <mat-hint class="error-hint">{{ fieldsErrorMessages.project }}</mat-hint>
            }
          </mat-form-field>
        </div>

        <div class="form-group container1">
          <div class="column">
            <label class="mb-2 input-label mandatory"><span>*</span> {{ variables.selectFromCatalog }}</label>
            <br>
            <mat-form-field class="form-field2" appearance="outline">
              <mat-select formControlName="catalogCtrl" placeholder="">
                <mat-option>
                  <ngx-mat-select-search formControlName="catalogFilterCtrl" [placeholderLabel]="variables.search"
                    [noEntriesFoundLabel]="variables.noCatalogFound" search
                    (keyup)="filterCatalogs()"></ngx-mat-select-search>
                </mat-option>
                @for (item of filteredCatalogs; track item.id) {
                <mat-option [value]="item.id" (click)="onChangeTechCatalog(item.id)">
                  {{ item.name }}
                </mat-option>
                }
              </mat-select>
              @if (invalidFields.catalog) {
              <mat-hint class="error-hint">{{ fieldsErrorMessages.catalog }}</mat-hint>
              }
            </mat-form-field>
          </div>
        </div>

        @if (isCatalogSelected) {
        <div class="form-group">
          <label class="mb-2 input-label mandatory"><span>*</span> {{ variables.selectProjectMetodology }}</label>
          <mat-form-field class="form-field" appearance="outline">
            <mat-select formControlName="metodologyProjectCtrl" placeholder=""
              (selectionChange)="onMetodologyChange($event)">
              @for (item of metodologyTypes; track item.id) {
              <mat-option [value]="item.id">
                {{ item.name }}
              </mat-option>
              }
            </mat-select>
            @if (invalidFields.projectMethodology) {
            <mat-hint class="error-hint">{{ fieldsErrorMessages.projectMethodology }}</mat-hint>
            }
          </mat-form-field>
        </div>
        }

        @if (estimativaForm.value.metodologyProjectCtrl === 'agile') {
        <div class="form-group">
          <label class="mb-2 input-label mandatory"><span>*</span> {{ variables.selectEstimateMetodology }}</label>
          <mat-form-field class="form-field" appearance="outline">
            <mat-select formControlName="estimateModelCtrl" placeholder="" (selectionChange)="onModeChange($event)">
              @for (item of estimateModelTypes; track item.id) {
              <mat-option [value]="item.id">
                {{ item.name }}
              </mat-option>
              }
            </mat-select>
            @if (invalidFields.agileModels) {
            <mat-hint class="error-hint">{{ fieldsErrorMessages.agileModels }}</mat-hint>
            }
          </mat-form-field>
        </div>
        }
      </div>

      @if (showAiSection) {
      <div class="section ai-section">
        <div class="ai-section-header">
          <mat-icon class="ai-icon-header">auto_awesome</mat-icon>
          <h3 class="section-name" style="margin:0;">{{ variables?.aiSectionTitle || 'Generar actividades con IA' }}</h3>
        </div>
        <p class="ai-section-description">{{ variables?.aiSectionDescription || 'Sube un documento funcional y deja que la IA sugiera las macro-actividades y subtareas para esta estimación.' }}</p>
        @if (hasPendingAiGeneratedData) {
        <div class="ai-regenerate-warning">
          <mat-icon class="ai-regenerate-warning-icon">warning_amber</mat-icon>
          <span>{{ variables?.aiPendingReplacementWarning || 'There is unsaved AI-generated data. Generating again will replace it.' }}</span>
        </div>
        }
        <div>
          <app-button typeBtn="secondary" (click)="openAiGenerateDialog()" iconPosition="left" icon="auto_awesome"
            message="{{ variables?.generateWithAi || 'Generar con IA' }}"></app-button>
        </div>
      </div>
      }

      <div #projectTypeSection></div>

      @if (projectTypes.length > 0) {
      <div class="section">
        <h3 class="section-name">{{ variables.projectType }} <span>*</span></h3>
        <div class="form-group">
          <label class="mb-2 input-label mandatory"><span>*</span> {{ variables.selectProjectType }}</label>

          <div formArrayName="projectTypeCtrl" class="radio-group">
            @for (group of estimativaForm.get('projectTypeCtrl')['controls']; track $index; let i = $index) {
            <div [formGroupName]="i" class="radio-item-container flex">
              <mat-radio-button class="radio-group-item" [checked]="group.get('selected')?.value"
                (change)="onProjectTypeSelected(i)"
                [matTooltip]="group.get('styleField')?.value === 'colorGray' ? variables.optionNotInCatalog : ''">
                {{ group.get('name')?.value }} ({{ variables.associatedRisks }} {{ group.get('risk')?.value
                }}%)
              </mat-radio-button>

              <div class="action_buttons ms-2">
                <span class="action_buttons-item" (click)="openDialogEditValue(group.value)">
                  <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
                </span>
              </div>
            </div>
            }
          </div>
          @if (invalidFields.projectType) {
          <div class="error-hint">
            {{ fieldsErrorMessages.projectType }}
          </div>
          }
        </div>
      </div>
      }

      <div #configurationSection></div>
      @if (configurations.length > 0) {
      <div class="section">
        <h3 class="section-name">{{ variables.configuration }}
          <!-- <span>*</span> -->
        </h3>
        <div class="form-group">
          <label class="mb-2 input-label">{{ variables.selectConfiguration }}</label>
          <div formArrayName="configurationCtrl">
            @for (configGroup of estimativaForm.get('configurationCtrl').controls; track $index; let i = $index)
            {
            <div [formGroupName]="i" style="display:flex">
              <mat-checkbox formControlName="selected" [ngStyle]="getStyle(configurations[i])"
                [matTooltip]="configurations[i].styleField === 'colorGray' ? variables.optionNotInCatalog : ''">
                {{ configurations[i].name }} - {{ configGroup.get('complexity')?.value }}h ({{ getProfileNameForDisplay(configGroup.get('profileId')?.value) }})
              </mat-checkbox>
              <div class="action_buttons ms-2">
                <span class="action_buttons-item" (click)="openProfileDialog(i,'configurationCtrl')" [matTooltip]="variables.selectProfile || 'Seleccionar Perfil'">
                  <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
                </span>
              </div>
            </div>
            }
          </div>
          @if (invalidFields.configuration) {
          <div class="error-hint">
            {{ fieldsErrorMessages.configuration }}
          </div>
          }
        </div>
      </div>
      }

      <div #parametersSection></div>
      @if (parameters.length > 0) {
      <div class="section">
        <h3 class="section-name">{{ variables.parameters }}
          <!-- <span>*</span> -->
        </h3>
        <div class="form-group">
          <label class="mb-2 input-label">{{ variables.selectParams }}</label>
          <div formArrayName="parametersCtrl">
            @for (paramGroup of estimativaForm.get('parametersCtrl').controls; track $index; let i = $index) {
            <div [formGroupName]="i" style="display:flex">
              <mat-checkbox formControlName="selected"  [ngStyle]="getStyle(parameters[i])"
                [matTooltip]="parameters[i].styleField === 'colorGray' ? variables.optionNotInCatalog : ''">
                {{ parameters[i].name }} - {{ paramGroup.get('complexity')?.value }}h ({{ getProfileNameForDisplay(paramGroup.get('profileId')?.value) }})
              </mat-checkbox>
              <div class="action_buttons ms-2">
                <span class="action_buttons-item" (click)="openProfileDialog(i,'parametersCtrl')" [matTooltip]="variables.selectProfile || 'Seleccionar Perfil'">
                  <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
                </span>
              </div>

            </div>
            }
          </div>
          @if (invalidFields.parameters) {
          <div class="error-hint">
            {{ fieldsErrorMessages.parameters }}
          </div>
          }
        </div>
      </div>
      }

      <div #macroSection></div>
      @if (macroActivities.length > 0 && estimativaForm.value.metodologyProjectCtrl !== '') {
      <div class="section">
        <h3 class="section-name">{{ variables.macroActivities }} <span>*</span></h3>
        <div class="form-group">
          <label class="mb-2 input-label mandatory"><span>*</span> {{ variables.selectMetodologyAndMacros }}</label>

          <!-- AI Macro Warning Message -->
          @if (showAiMacroWarning) {
          <div class="ai-macro-warning" style="display: flex; align-items: center; background: #fff3cd; color: #856404; border: 1px solid #ffeeba; border-radius: 4px; padding: 8px 12px; margin-bottom: 12px;">
            <mat-icon style="margin-right: 8px; color: #856404;">warning_amber</mat-icon>
            <span>{{ variables?.aiMacroWarningMessage || 'Algunas macro-actividades seleccionadas han sido reemplazadas por IA. Revísalas antes de guardar o generar nuevas.' }}</span>
          </div>
          }

          <div formArrayName="macroTypeCtrl">
            @for (macroGroup of estimativaForm.get('macroTypeCtrl').controls; track $index; let i = $index) {
            <div [formGroupName]="i" class="macro-item-row">
              <mat-checkbox formControlName="selected" [ngStyle]="getStyle(macroGroup.value)"
                [matTooltip]="filteredMacros[i]?.styleField === 'colorGray' ? variables.optionNotInCatalog : ''"
                class="macro-checkbox">
                {{ macroGroup.get('name')?.value }} - {{ macroGroup.get('effort')?.value.toFixed(2) }}% ({{ getProfileNameForDisplay(macroGroup.get('profileId')?.value) }})
              </mat-checkbox>
              @if (macroGroup.get('aiGenerated')?.value && macroGroup.get('selected')?.value) {
              <mat-icon class="ai-generated-icon"
                [matTooltip]="variables?.aiReviewTooltip || 'Por favor revise toda la información generada por IA, una vez validada pulse en guardar'">
                auto_awesome
              </mat-icon>
              }
              <div class="action_buttons profile-edit-button">
                <span class="action_buttons-item" (click)="openProfileDialog(i,'macroTypeCtrl')" [matTooltip]="variables.selectProfile || 'Seleccionar Perfil'">
                  <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
                </span>
              </div>
            </div>
            }
          </div>

          @if (invalidFields.macroType) {
          <div>
            <mat-hint class="error-hint">
              {{ fieldsErrorMessages.macroType }}
            </mat-hint>
          </div>
          }

          @if (invalidFields.macro) {
          <div>
            <mat-hint class="error-hint">
              {{ fieldsErrorMessages.macro }}
            </mat-hint>
          </div>
          }
        </div>
      </div>
      }

      <div class="btn-group mb-2">
        <!-- <app-button typeBtn="secondary" (click)="goToDashboard()" iconPosition="left" iconSize="20px"
          icon="arrow_backward" class="mr-1" message="{{ variables.anterior }}"></app-button> -->
        <app-button typeBtn="secondary" [disabled]="estimativaForm.status !== 'VALID' || isReadOnly"
          (click)="activity()" class="mr-1" message="{{ variables.next }}"></app-button>
        <app-button typeBtn="primary" [disabled]="estimativaForm.status !== 'VALID' || isReadOnly"
          (click)="saveEstimate()" message="{{ variables.save1 }}"></app-button>
      </div>
    </form>
  </div>
</div>